import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-common-save",
  "use": "icon-common-save-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 14\" fill=\"none\" id=\"icon-common-save\">\n  <path d=\"M9.62859 1.31274H4.37728C4.0291 1.31274 3.69517 1.45106 3.44897 1.69726C3.20277 1.94347 3.06445 2.27739 3.06445 2.62557V12.6906L7.00293 9.1897L10.9414 12.6906V2.62557C10.9414 2.27739 10.8031 1.94347 10.5569 1.69726C10.3107 1.45106 9.97677 1.31274 9.62859 1.31274Z\" stroke=\"currentColor\" stroke-width=\"1.00189\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol